/* eslint-disable */
class Lang {
	name;

	render() {
		return this.template.getHTML(this);
	}
}
export { Lang };



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_googletranslate/entities/Lang.js